import {BaseWeatherCollection} from "./_BaseLocationCollection";


export class LocationCollection extends BaseWeatherCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/app/' +  this.appUrlRoot + '/locations';
    };

    comparator = (model) => {
        return model.get('name');
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/weather/collections/Locations.ts